import PropTypes from 'prop-types';
import classnames from 'classnames';

import dibsCss from 'dibs-css';
import styles from './SharedBottomModuleSpacer.scss';

export const SharedBottomModuleSpacer = ({ className, bottomModule, children }) => {
    if (!bottomModule || !bottomModule.length) {
        return null;
    }
    return (
        <div
            className={classnames(
                classnames(styles.wrapper, dibsCss.ptLarge, dibsCss.px0, dibsCss.pbSmall),
                className
            )}
        >
            {children}
        </div>
    );
};

SharedBottomModuleSpacer.propTypes = {
    className: PropTypes.string,
    bottomModule: PropTypes.array,
    children: PropTypes.node,
};
